export const getters = {
  hasTrack: (state) => Boolean(state.track),
  hasAudioUrl: (state) => Boolean(state.track?.audioUrl),
};
